import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import TaskExecLogsBlock from '../TaskExecLogsBlock';
import TasksExecsFormsBlockAsExecutor from '../../../TasksExecsForms/TasksExecsFormsBlockAsExecutor';
import Header from './Header';
import TaskPanelBodyAsExec from '../../../_common/TaskPanelBodyAsExec';

const execLogTabName = 'execLogTab';
const taskParamsTabName = 'taskParamsTab';

// eslint-disable-next-line react/prefer-stateless-function
class TaskExecItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabActive: execLogTabName
    };
  }

  handleChangeTab = (e, tabName) => {
    e.preventDefault();
    this.setState({ tabActive: tabName });
  };

  render() {
    if (!this.props.exec) {
      return <p>Element not found</p>;
    }

    let execStatusIconClass = null;
    switch (this.props.exec.status) {
      case 1: {
        execStatusIconClass = 'text-success fa fa-play-circle';
        break;
      }
      case 2: {
        execStatusIconClass = 'text-info fa fa-file-text';
        break;
      }
      case 3: {
        execStatusIconClass = 'text-danger fa fa-undo';
        break;
      }
      case 4: {
        execStatusIconClass = 'text-success fa fa-check-circle';
        break;
      }
      case 5: {
        execStatusIconClass = 'text-danger fa fa-times-circle';
        break;
      }
      case 6: {
        execStatusIconClass = 'text-danger fa fa-times-circle';
        break;
      }
      case 7: {
        execStatusIconClass = 'text-warning fa fa-gavel';
        break;
      }
      default:
        break;
    }

    let body;
    if (this.state.tabActive === execLogTabName) {
      body = (
        <TaskExecLogsBlock
          execId={this.props.exec.id}
          lastExecLog={this.props.exec.lastExecLog}
        />
      );
    } else if (this.state.tabActive === taskParamsTabName) {
      body = <TaskPanelBodyAsExec task={this.props.exec.task} />;
    }
    return (
      <article className="panel panel-default task task_detailed">
        <Header {...this.props} />
        <div className="panel-bar">
          <div className="hor-scroll hor-scroll_xs hor-scroll_sub">
            <ul className="nav nav-tabs hor-scroll-wrapper">
              <li className="active">
                <a
                  data-toggle="tab"
                  href=""
                  onClick={e => this.handleChangeTab(e, execLogTabName)}
                >
                  <i
                    data-toggle="tooltip"
                    className={execStatusIconClass}
                    title={this.props.exec.statusName}
                  />{' '}
                  {t('Выполнение {id}', { id: `ID-${this.props.exec.id}` })}
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href=""
                  onClick={e => this.handleChangeTab(e, taskParamsTabName)}
                >
                  {t('Параметры')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="panel-body border-simple-b">{body}</div>
        <TasksExecsFormsBlockAsExecutor {...this.props} />
      </article>
    );
  }
}

TaskExecItem.propTypes = {
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired,
    ownerId: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    statusName: PropTypes.string.isRequired,
    ownerName: PropTypes.string,
    ownerAvatarPath: PropTypes.string,
    lastExecLog: PropTypes.shape.isRequired,
    task: PropTypes.shape.isRequired
  }).isRequired
};

export default withRouter(TaskExecItem);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecItem/TaskExecItem.js